"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdHelper = exports.randomstring = exports.sha1 = exports.uuidv5 = exports.uuidv4 = exports.uuidv3 = exports.uuidv1 = exports.alphabet = exports.slash = exports.dash = exports.separator = exports.Region = exports.swappedRegions = exports.regions = exports.swappedTypes = exports.types = void 0;
const sha1_1 = __importDefault(require("sha1"));
exports.sha1 = sha1_1.default;
const smash_type_1 = require("smash-type");
Object.defineProperty(exports, "Region", { enumerable: true, get: function () { return smash_type_1.Region; } });
Object.defineProperty(exports, "separator", { enumerable: true, get: function () { return smash_type_1.separator; } });
Object.defineProperty(exports, "dash", { enumerable: true, get: function () { return smash_type_1.dash; } });
Object.defineProperty(exports, "slash", { enumerable: true, get: function () { return smash_type_1.slash; } });
const object_hash_1 = __importDefault(require("object-hash"));
const randomstring_1 = __importDefault(require("randomstring"));
exports.randomstring = randomstring_1.default;
exports.types = {
    transfer: 't',
    report: 'r',
    officer: 'o',
    service: 's',
    account: 'a',
    user: 'u',
    plan: 'p',
    team: '7',
    promotion: '9',
    group: 'g',
    dropbox: 'd',
    receipt: '6',
};
exports.swappedTypes = {
    t: 'transfer',
    r: 'report',
    o: 'officer',
    s: 'service',
    a: 'account',
    u: 'user',
    p: 'plan',
    7: 'team',
    9: 'promotion',
    g: 'group',
    d: 'dropbox',
    6: 'receipt',
};
exports.regions = {
    "eu-west-1": "a",
    "eu-west-2": "b",
    "eu-west-3": "c",
    "eu-central-1": "d",
    "us-east-1": "e",
    "us-east-2": "f",
    "us-west-1": "g",
    "us-west-2": "h",
    "ca-central-1": "i",
    "sa-east-1": "j",
    "ap-northeast-1": "k",
    "ap-northeast-2": "l",
    "ap-south-1": "m",
    "ap-southeast-1": "n",
    "ap-southeast-2": "o",
    "eu-north-1": "p",
    "eu-south-1": "q",
    "af-south-1": "r",
    "me-south-1": "s",
    "ap-northeast-3": "t",
    "ap-east-1": "u",
    "ap-south-2": "u",
    "ap-southeast-3": "w",
    "eu-south-2": "x",
    "eu-central-2": "y",
    "me-central-1": "z",
};
exports.swappedRegions = {
    a: "eu-west-1",
    b: "eu-west-2",
    c: "eu-west-3",
    d: "eu-central-1",
    e: "us-east-1",
    f: "us-east-2",
    g: "us-west-1",
    h: "us-west-2",
    i: "ca-central-1",
    j: "sa-east-1",
    k: "ap-northeast-1",
    l: "ap-northeast-2",
    m: "ap-south-1",
    n: "ap-southeast-1",
    o: "ap-southeast-2",
    p: "eu-north-1",
    q: "eu-south-1",
    r: "af-south-1",
    s: "me-south-1",
    t: "ap-northeast-3",
    u: "ap-east-1",
    v: "ap-south-2",
    w: "ap-southeast-3",
    x: "eu-south-2",
    y: "eu-central-2",
    z: "me-central-1",
};
exports.alphabet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_.-~";
var uuid_1 = require("uuid");
Object.defineProperty(exports, "uuidv1", { enumerable: true, get: function () { return uuid_1.v1; } });
Object.defineProperty(exports, "uuidv3", { enumerable: true, get: function () { return uuid_1.v3; } });
Object.defineProperty(exports, "uuidv4", { enumerable: true, get: function () { return uuid_1.v4; } });
Object.defineProperty(exports, "uuidv5", { enumerable: true, get: function () { return uuid_1.v5; } });
class IdHelper {
    constructor(region) {
        if (region) {
            this.region = region;
        }
    }
    set region(region) {
        if (this.regions[region]) {
            this._region = region;
        }
        else {
            throw new Error(`Unsupported region ${region}`);
        }
    }
    get region() {
        if (this._region) {
            return this._region;
        }
        throw new Error(`No region set in IdHelper`);
    }
    get encodedRegion() {
        return this.regions[this.region];
    }
    get separator() {
        return smash_type_1.separator;
    }
    get dash() {
        return smash_type_1.dash;
    }
    get slash() {
        return smash_type_1.slash;
    }
    get alphabet() {
        return exports.alphabet;
    }
    get regions() {
        return exports.regions;
    }
    get types() {
        return exports.types;
    }
    getSdkRegionFromId(id) {
        return this.getRegionFromId(id);
    }
    getRegionFromId(id) {
        return exports.swappedRegions[id[id.length - 2]];
    }
    getEncodedRegionFromId(id) {
        return this.regions[this.getRegionFromId(id)];
    }
    getTypeFromId(id) {
        return exports.swappedTypes[id[id.length - 1]];
    }
    getEncodedTypeFromId(id) {
        return this.types[this.getTypeFromId(id)];
    }
    getRegionFromString(string) {
        for (const region in this.regions) {
            if (string.indexOf(region) !== -1) {
                return region;
            }
        }
        return null;
    }
    generateRandomString(length) {
        let randomString = "";
        for (let i = 0; i < length; i++)
            randomString += this.alphabet.charAt(Math.floor(Math.random() * this.alphabet.length));
        return randomString;
    }
    generateEncodedEnd(type) {
        return this.dash + this.encodedRegion + type;
    }
    hashObject(data) {
        return (0, object_hash_1.default)(data);
    }
    isValidId(id) {
        const regexp = new RegExp('^.*-[' + Object.values(exports.regions).join('') + '][' + Object.values(exports.types).join('') + ']$');
        return regexp.test(id);
    }
}
exports.IdHelper = IdHelper;
